import React, { useState } from "react";
import { GuarantorsList } from "@/dentlab/src/components/list-components/guarantors-list.component";
import { GuarantorForm } from "@/dentlab/src/forms/form-components/guarantor/insert-update/guarantor.form";
import { Button } from "@/dentlab/src/components/ui/button";
import { ArrowLeft } from "lucide-react";

type ViewMode = 'list' | 'new' | 'edit';

export const GarantenVerwaltenPage: React.FC = () => {
	const [viewMode, setViewMode] = useState<ViewMode>('list');
	const [guarantorId, setGuarantorId] = useState<string | undefined>(
		undefined
	);

	const handleEdit = (id: string) => {
		setGuarantorId(id);
		setViewMode('edit');
	};

	const handleSave = () => {
		setViewMode('list');
		setGuarantorId(undefined);
	};

	const handleBack = () => {
		setViewMode('list');
		setGuarantorId(undefined);
	};

	return (
		<div className="p-6">
			<div className="max-w-6xl">
				<div className="flex items-center gap-4 mb-6">
					{viewMode !== 'list' && (
						<Button
							variant="ghost"
							size="icon"
							onClick={handleBack}
							className="h-8 w-8"
						>
							<ArrowLeft className="h-4 w-4" />
						</Button>
					)}
					<h1 className="text-2xl font-semibold text-gray-900">
						{viewMode === 'list' && 'Garanten'}
						{viewMode === 'new' && 'Neuer Garant'}
						{viewMode === 'edit' && 'Garant bearbeiten'}
					</h1>
				</div>

				<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
					{viewMode === 'list' && (
						<>
							<div className="mb-4">
								<Button onClick={() => setViewMode('new')}>
									Neuer Garant
								</Button>
							</div>
							<GuarantorsList onEdit={handleEdit} />
						</>
					)}

					{viewMode === 'new' && (
						<GuarantorForm
							onSave={handleSave}
						/>
					)}

					{viewMode === 'edit' && guarantorId && (
						<GuarantorForm
							guarantorId={guarantorId}
							onSave={handleSave}
						/>
					)}
				</div>
			</div>
		</div>
	);
};